const plan = {
  namespaced: true,
  state: {
    currentPlanId: null,
    setCurrentPlanAt: null,
    plans: [],
    assignablePlans: [],
    lastUpdated: null,
    fetchStart: null,
    fetchEnd: null,
    error: null
  },
  mutations: {
    SET_PLANS(state, plans) {
      state.plans = plans
    },
    SET_ASSIGNABLE_PLANS(state, assignablePlans) {
      state.assignablePlans = assignablePlans
    },
    ADD_PLANS(state, plans) {
      state.plans = [...state.plans, ...plans]
    },
    SET_CURRENT_PLAN(state, id) {
      state.currentPlanId = id
      state.setCurrentPlanAt = Date.now()
    },
    ARCHIVE_PLAN(state, id) {
      state.plans = state.plans.filter(p => p._id !== id)
    },
    FETCH_START(state) {
      state.fetchStart = Date.now()
    },
    FETCH_END(state) {
      state.fetchEnd = Date.now()
    },
    FETCH_ERROR(state, error) {
      state.error = error
    },
    UPLOAD_START(state) {
      state.fetchStart = Date.now()
    },
    UPLOAD_END(state) {
      state.fetchEnd = Date.now()
    },
    UPLOAD_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async fetchPlans({ commit }) {
      commit('FETCH_START')
      try {
        let { data: plans } = await this.$api.fetchPlans()
        plans = plans.filter(p => !p.archived)
        commit('SET_PLANS', plans)
        commit('FETCH_END')
        return Promise.resolve()
      } catch (err) {
        commit('FETCH_ERROR', { name: 'getPlans', err, date: Date.now() })
        return Promise.reject(err)
      }
    },
    async fetchAssignablePlans({ commit }) {
      commit('FETCH_START')
      try {
        let { data: plans } = await this.$api.fetchAssignablePlans()
        plans = plans.filter(p => !p.archived)
        commit('SET_ASSIGNABLE_PLANS', plans)
        commit('FETCH_END')
        return Promise.resolve()
      } catch (err) {
        commit('FETCH_ERROR', {
          name: 'fetchAssignablePlans',
          err,
          date: Date.now()
        })
        return Promise.reject(err)
      }
    },
    async uploadPlans({ commit }, plans) {
      commit('UPLOAD_START')
      try {
        const { data } = await this.$api.uploadPlan(plans)
        console.log({ data })
        commit('ADD_PLANS', data)
        commit('UPLOAD_END')
        return Promise.resolve()
      } catch (err) {
        commit('UPLOAD_ERROR', err)
        return Promise.reject(err)
      }
    },
    setCurrentPlanId({ commit }, id) {
      commit('SET_CURRENT_PLAN', id)
    },
    async archive({ commit }, id) {
      try {
        const { data } = await this.$api.archivePlan(id)
        console.log({ data })
        commit('ARCHIVE_PLAN', data._id)
      } catch (err) {
        console.log({ err })
      }
    }
  },
  getters: {
    plans: state => [...state.plans],
    assignablePlans: state => [...state.assignablePlans],
    currentPlanId: state => state.currentPlanId,
    currentPlan: state =>
      [...state.plans].find(plan => plan._id === state.currentPlanId)
  }
}

export default plan
